import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface CoreState {
  isInitializing: boolean;
  [key: string]: any;
}

const initialState: CoreState = {
  isInitializing: false,
};

export const fetchCoreThunk = createAsyncThunk(
  'core/fetchCore',
  async (_, { rejectWithValue }) => {
    try {
      // Add your core data fetching logic here
      // For now, just return a resolved promise
      return {};
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch core data');
    }
  }
);

const coreSlice = createSlice({
  name: 'core',
  initialState,
  reducers: {
    setInitializing: (state, action) => {
      state.isInitializing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCoreThunk.pending, (state) => {
        state.isInitializing = true;
      })
      .addCase(fetchCoreThunk.fulfilled, (state) => {
        state.isInitializing = false;
      })
      .addCase(fetchCoreThunk.rejected, (state) => {
        state.isInitializing = false;
      });
  },
});

export const { setInitializing } = coreSlice.actions;
export default coreSlice.reducer;

